"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable: no-unused-expression
const browser_1 = require("./browser");
const hashString_1 = require("./hashString");
const helpers_1 = require("./helpers");
const getCookieValues = (key) => {
    const b = [];
    const c = browser_1.default.getDocument().cookie.split(';');
    const rx = new RegExp('^\\s*' + key + '=\\s*(.*?)\\s*$');
    for (const d of c) {
        const e = d.match(rx);
        e && b.push(e[1]);
    }
    return b;
};
exports.getCookieValues = getCookieValues;
const scanCookieValueByHash = (key, cookieValues) => {
    let hashedKey;
    let hashedKeyNoDot;
    if (key === null) {
        hashedKey = hashedKeyNoDot = 1;
    }
    else {
        hashedKey = hashString_1.default(key);
        hashedKeyNoDot = hashString_1.default(helpers_1.default.startsWith(key, '.') ? key.substring(1) : '.' + key);
    }
    for (const cookieValue of cookieValues) {
        if (cookieValue.hash === '' + hashedKey || cookieValue.hash === '' + hashedKeyNoDot) {
            return cookieValue;
        }
    }
};
exports.scanCookieValueByHash = scanCookieValueByHash;
const findCookieValueByHash = (key, cookieDomain, host) => {
    if (cookieDomain === 'none') {
        cookieDomain = '';
    }
    const results = [];
    const cookieValues = getCookieValues(key);
    const offset = ('__utma' === key) ? 6 : 2;
    for (const cookieValue of cookieValues) {
        const cookieValueTokens = ('' + cookieValue).split('.');
        cookieValueTokens.length >= offset && results.push({
            hash: cookieValueTokens[0],
            R: cookieValue,
            O: cookieValueTokens,
        });
    }
    if (0 !== results.length) {
        return 1 === results.length
            ? results[0]
            : scanCookieValueByHash(cookieDomain, results)
                || scanCookieValueByHash(host, results)
                || scanCookieValueByHash(null, results)
                || results[0];
    }
};
exports.findCookieValueByHash = findCookieValueByHash;
const setCookie = (key, value, path, domain, expires) => {
    let newval = value;
    if (newval && 1200 < newval.length) {
        newval = newval.substring(0, 1200);
    }
    newval = key + '=' + newval + '; path=' + path + '; ';
    if (expires) {
        newval += 'expires=' + new Date((new Date()).getTime() + expires).toGMTString() + '; ';
    }
    if (domain && 'none' !== domain) {
        newval += 'domain=' + domain + '; ';
    }
    newval += 'SameSite=Lax;';
    const cookie = browser_1.default.getDocument().cookie;
    browser_1.default.getDocument().cookie = newval;
    let changed = cookie !== browser_1.default.getDocument().cookie;
    if (!changed) {
        // tslint:disable-next-line: label-position
        a: {
            const values = getCookieValues(key);
            for (const v of values) {
                if (v === newval) {
                    changed = true;
                    break a;
                }
            }
            changed = false;
        }
    }
    return changed;
};
exports.setCookie = setCookie;
const encodeCookieText = (input) => {
    return encodeURIComponent ? encodeURIComponent(input).replace(/\(/g, '%28').replace(/\)/g, '%29') : input;
};
exports.encodeCookieText = encodeCookieText;
